// extracted by mini-css-extract-plugin
module.exports = {"container":"Legal_container__1Utbx","back":"Legal_back__1SOYU","content":"Legal_content__3VTIT","bloc":"Legal_bloc__2346f","intro":"Legal_intro__2qPqA","end":"Legal_end__3nHW9"};